import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';

import _cloneDeep from 'lodash/cloneDeep';
import _last from 'lodash/fp/last';
import _isNaN from 'lodash/fp/isNaN';

import http from '../../shared/http';
import endpoints from '../../../config/endpoints';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';

import createGeneralForm from '../components/forms/general';
import { createSelectOptionsFromSysEnums } from '../../shared/form-elements/select';

const mainForm = createGeneralForm({
	namespace: 'bmAccountsEditor',
	stateNodeName: 'mainForm'
});

const TOGGLE_PROGRESS_BAR = 'bmAccountsEditor/toggle-progress-bar';
const FETCH_ACCOUNTS_SUCCESS = 'bmAccountsEditor/fetch-accounts-success';
const FETCH_ERROR = 'bmAccountsEditor/fetch-error';
const SET_EMPTY_DATA = 'bmAccountsEditor/get-empty-data';
const SET_DATA_TO_NULL = 'bmAccountsEditor/set-data-to-null';
const CATEGORIES_LOOKUP_SUCCESS = 'bmAccountsEditor/categories-lookup-success';

export const allowedPermissions = {
	'view': 'bm_accounts_view',
	'edit': 'bm_accounts_update'
};

const initialState = {
	data: null,
	good: null,
	showProgressBar: false,
	mainForm: mainForm.initialState,
	error: false
};

const getTabLangs = currentLanguage => state => {
	const { defaultLanguage } = state.bmAccountsEditor;
	const langs = state.root.lists.languages;
	return langs.map(lang => ({
		...lang,
		isSelected: true,
		isActive: lang.id === currentLanguage,
		isDefault: lang.id === defaultLanguage
	}));
};

export const actions = Object.assign({

	fetchData: () => dispatch => {
		const { pathname } = window.location;
		let lastParams = parseInt(_last(pathname.split('/')));

		if (_isNaN(lastParams)) return dispatch({type: SET_EMPTY_DATA});

		const request = http({
			url: `${endpoints.BM_ACCOUNTS.BASE}/${lastParams}`,
			method: 'get',
			actions: [ FETCH_ACCOUNTS_SUCCESS, FETCH_ERROR ]
		});

		return request(dispatch);
	},

	setDataToNull: () => ({ type: SET_DATA_TO_NULL }),

	toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR }),

	bmCategoriesLookup: text => (dispatch, getState) => {
		const request = http({
			url: endpoints.LOOKUPS.BM_ACCOUNTS_CATEGORIES,
			method: 'get',
			actions: [CATEGORIES_LOOKUP_SUCCESS, FETCH_ERROR],
			query: { query: text }
		});

		return request(dispatch).then(action => {
			if (action.type === CATEGORIES_LOOKUP_SUCCESS) {
				return { options: action.payload.data.map(item => ({ value: item.id, label: item.text })) };
			}
		});
	}
},
mainForm.actions
);

const reducers = Object.assign({
	[SET_EMPTY_DATA]: (state, action) => ({
		...state,
		data: {},
		showProgressBar: false
	}),
	[SET_DATA_TO_NULL]: state => ({ ...state, data: null }),
	[LOCATION_CHANGE]: (state, action) => {
		return initialState;
	},
	[FETCH_ACCOUNTS_SUCCESS]: (state, action) => {
		return {
			...state,
			data: action.payload.data,
			showProgressBar: false
		};
	},
	[FETCH_ERROR]: state => ({ ...state, error: true, showProgressBar: false}),
	[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar })
},
mainForm.reducers
);

export default handleActions(reducers, _cloneDeep(initialState));

export const selectors = {
	getData: state => state.bmAccountsEditor.data,
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getProgressBar: state => state.bmAccountsEditor.showProgressBar,
	getMainFormData: mainForm.selectors.getMainFormData,
	getError: state => state.bmAccountsEditor.error,
	getCurrencyOptions: state => {
		return createSelectOptionsFromSysEnums(state.root.lists['available-currencies']);
	},
	getMainTabLangs: state => {
		const { currentLanguage } = state.bmAccountsEditor.mainForm;
		return getTabLangs(currentLanguage)(state);
	},
	getCurrentLanguage: mainForm.selectors.getCurrentLanguage
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/bm-accounts/editor/index.js